import { formatDate, ISO_DATE_FORMAT } from 'helpers/formatters/date_time_formats';

import type { CustomFieldSchema } from 'bundles/crm/types';
import type { Filters } from 'bundles/apex/custom_fields/filters/types';

export function filterSchemas(schemas: CustomFieldSchema[], filterFunction?: (schema: CustomFieldSchema) => boolean) {
  if (!filterFunction) {
    return schemas;
  }

  return schemas.filter(filterFunction);
}

export function filterCustomFieldFilters(
  schemas: CustomFieldSchema[],
  filters: Filters,
  filterFunction?: (schema: CustomFieldSchema) => boolean
) {
  const filteredFilters: Filters = {};

  for (const schema of filterSchemas(schemas, filterFunction)) {
    if (schema.slug in filters) {
      const value = filters[schema.slug];
      if (value != null && value !== '' && (typeof value !== 'object' || Object.values(value).filter(Boolean).length)) {
        filteredFilters[schema.slug] = value;
      }
    }
  }

  return filteredFilters;
}

export function hasFilters(
  schemas: CustomFieldSchema[],
  filters: Filters,
  filterFunction?: (schema: CustomFieldSchema) => boolean
) {
  return !!Object.values(filterCustomFieldFilters(schemas, filters, filterFunction)).length;
}

export function buildQueryParams(
  schemas: CustomFieldSchema[],
  filters: Filters,
  filterFunction?: (schema: CustomFieldSchema) => boolean
) {
  const params: Record<string, any> = {};

  for (const slug in filterCustomFieldFilters(schemas, filters, filterFunction)) {
    const filter = filters[slug];
    const schema = schemas.find(schema => schema.slug === slug);
    if (!schema) {
      continue;
    }

    if (typeof filter === 'object') {
      let { min, max } = filter;
      if (schema.valueType === 'date') {
        min = formatDate(min, ISO_DATE_FORMAT);
        max = formatDate(max, ISO_DATE_FORMAT);
      }

      if (min != null && min !== '') {
        params[`custom_field_filters[${slug}_gteq]`] = min;
      }

      if (max != null && max !== '') {
        params[`custom_field_filters[${slug}_lteq]`] = max;
      }
    } else if (filter != null && filter !== '') {
      params[`custom_field_filters[${slug}_cont]`] = filter;
    }
  }

  return params;
}
